<template>
    <div>
        <section v-if="wallets.length > 0">
            <div class="row mt-4">
                <div class="col-md-12">
                    <div class="wallet-flex">
                        <div class="wallet-item-flex">
                            <div class="mx-4 align-self-end" id="lg_wallet_list">
                                <select
                                        class="form-control"
                                        id="dashboard_data_select_m"
                                        name=""
                                        style="box-shadow: 0 0 5px #8ce3d6"
                                        v-model="walletSelected"
                                >
                                    <option :key="wallet.id" :value="wallet.id" v-for="wallet in wallets">
                                        {{ wallet.wallet_title }}
                                    </option>
                                </select>
                            </div>
                            <div>
                                <div class="d-block mt-3 title_font_size en_num">
                  <span v-if="walletData.status === 1">
                    {{
                      $t("wallets.label.id")
                    }} : {{ walletData.id }}
                  </span>
                                    <span class="badge badge-danger px-5 py-3" v-else>{{ $t("status.deactive") }}</span>
                                    <div
                                            @click="copyText(walletData.id)"
                                            class="btn m-0 pl-2 pr-0 py-1 border-success mr-2"
                                            style="cursor: pointer"
                                            v-if="walletData.status === 1"
                                    >
                                        <i class="fas fa-copy text-success" id="btn_copy_wallet_hashid"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Mobile Size -->
                        <div class="wallet-item-flex">
                            <div class="mx-4 my-2 col-md-12 m-0 p-0" id="wallet_list_mobile_view">
                                <select
                                        class="form-control"
                                        id="dashboard_data_select"
                                        name=""
                                        style="box-shadow: 0 0 5px #8ce3d6"
                                        v-model="walletSelected"
                                >
                                    <option :key="wallet.id" :value="wallet.id" v-for="wallet in wallets">
                                        {{ wallet.wallet_title }}
                                    </option>
                                </select>
                            </div>
                            <div :style="disabledNoneActiveWallet" class="w-sm-100">
                                <router-link class="btn btn-success w-sm-100 py-2" to="/shareholders">{{
                                    $t("label.shareholders")
                                    }}
                                </router-link>
                            </div>
                            <div class="w-sm-100">
                                <router-link
                                        class="btn btn-success w-sm-100 ml-create-wallet py-2"
                                        to="/wallets/create"
                                >{{ $t('wallets.label.create-wallet') }}
                                </router-link
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-6 col-md my-2">
                    <dashboard-box
                        :has_rail="true"
                        :number="walletData.total_amount"
                        color="#FF8D8D"
                        title="موجودی کل"
                        :showReloadButton="true"
                        :isLoading="isLoading"
                        @reload="reloadBalanceMethod(walletData.id)"
                    >
                        <svg
                                fill="#fff"
                                height="24px"
                                viewBox="0 0 24 24"
                                width="24px"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path
                                    d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                            />
                        </svg>
                    </dashboard-box>
                </div>
                <div class="col-6 col-md my-2">
                    <dashboard-box
                        :has_rail="true"
                        :number="walletData.available_amount"
                        color="#00bea5"
                        info="مقادیر بدون احتساب کارمزد برداشت از کیف ارائه گردیده است."
                        title="موجودی قابل برداشت"
                        :showReloadButton="true"
                        :isLoading="isLoading"
                        @reload="reloadBalanceMethod(walletData.id)"
                    >
                        <svg
                                enable-background="new 0 0 24 24"
                                fill="#fff"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                            <g>
                                <rect fill="none" height="24" width="24"/>
                            </g>
                            <g>
                                <g>
                                    <rect height="7" width="3" x="4" y="10"/>
                                    <rect height="7" width="3" x="10.5" y="10"/>
                                    <rect height="3" width="20" x="2" y="19"/>
                                    <rect height="7" width="3" x="17" y="10"/>
                                    <polygon points="12,1 2,6 2,8 22,8 22,6"/>
                                </g>
                            </g>
                        </svg>
                    </dashboard-box>
                </div>
                <div class="col-6 col-md my-2">
                    <dashboard-box
                            :has_rail="true"
                            :number="walletData.charge_pending_amount"
                            color="#FF8D8D"
                            info="تراکنش های که قابلیت انتقال کیف به کیف را دارند ولی تا تسویه بانک قابلیت برداشت ندارند."
                            title="موجودی در حال شارژ"
                    >
                        <svg
                                enable-background="new 0 0 24 24"
                                fill="#fff"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                            <g>
                                <rect fill="none" height="24" width="24"/>
                            </g>
                            <g>
                                <path
                                        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76V19h-1.75v-1.29
                  c-0.74-0.18-2.39-0.77-3.02-2.96l1.65-0.67c0.06,0.22,0.58,2.09,2.4,2.09c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03
                  c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5h1.75v1.24c1.84,0.32,2.51,1.79,2.66,2.23l-1.58,0.67
                  c-0.11-0.35-0.59-1.34-1.9-1.34c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45
                   C15.9,17.17,13.4,17.67,12.88,17.76z"
                                />
                            </g>
                        </svg>
                    </dashboard-box>
                </div>
                <div class="col-6 col-md my-2">
                    <dashboard-box
                            :has_rail="true"
                            :number="walletData.blocked_amount"
                            color="#00bea5"
                            title="موجودی بلوکه شده"
                    >
                        <svg
                                enable-background="new 0 0 24 24"
                                fill="#fff"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                            <g>
                                <rect fill="none" height="24" width="24"/>
                            </g>
                            <g>
                                <path
                                        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76V19h-1.75v-1.29
                  c-0.74-0.18-2.39-0.77-3.02-2.96l1.65-0.67c0.06,0.22,0.58,2.09,2.4,2.09c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03
                  c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5h1.75v1.24c1.84,0.32,2.51,1.79,2.66,2.23l-1.58,0.67
                  c-0.11-0.35-0.59-1.34-1.9-1.34c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45
                   C15.9,17.17,13.4,17.67,12.88,17.76z"
                                />
                            </g>
                        </svg>
                    </dashboard-box>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-3 my-1 my-button">
                    <div class="dropdown w-100">
                        <div
                                :style="disabledNoneActiveWallet"
                                class="px-4 title_font_size_btn btn dropdown-toggle w-100 d-flex justify-content-around"
                                data-toggle="dropdown"
                                style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6"
                                type="button"
                        >
                            <svg
                                    :style="showLockIcon"
                                    class="display-none-in-sm"
                                    data-v-3cc0e907=""
                                    fill="#a0a0a0"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    xmlns="http://www.w3.org/2000/svg"
                            >
                                <g data-v-3cc0e907="" fill="none">
                                    <path d="M0 0h24v24H0V0z" data-v-3cc0e907=""></path>
                                    <path d="M0 0h24v24H0V0z" data-v-3cc0e907="" opacity=".87"></path>
                                </g>
                                <path
                                        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                                        data-v-3cc0e907=""
                                ></path>
                            </svg>

                            <span class="m-icon-one router-link-white text-center">
                <svg
                        class="bi bi-graph-up-arrow mx-3"
                        fill="currentColor"
                        height="16"
                        viewBox="0 0 16 16"
                        width="16"
                        xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                          d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"
                          fill-rule="evenodd"
                  />
                </svg>
                {{ $t("wallets.label.charge_wlt") }}</span
                            >
                        </div>
                        <div class="dropdown-menu w-100 title_font_size">
                            <router-link
                                    :to="`/wallets/charge-by-oauth/${walletData.id}`"
                                    class="dropdown-item"
                                    v-text="$t('wallets.label.direct_dbite')"
                            >
                            </router-link>
<!--                            <router-link-->
<!--                                    :to="`/wallets/charge/${walletData.id}`"-->
<!--                                    class="dropdown-item"-->
<!--                                    v-text="$t('wallets.label.charge_by_direct_payment')"-->
<!--                            >-->
<!--                            </router-link>-->

                            <!-- Desktop Size -->
                            <ul
                                    class="dropdowns dropdown-item cp_pointer"
                                    v-if="showTransactionGateway"
                            >
                                <li>
                                    <a class="text-dark router-link-white">
                    <span class="router-link-white">
                      {{ $t("wallets.label.transaction_gateway") }}</span
                    >
                                    </a>
                                    <ul class="dropdown-menu">
                                        <li>
                                            <div :key="gateway.id" v-for="gateway in gateways">
                                                <router-link
                                                        :to="`/settlement-settings/ipg/${gateway.id}`"
                                                        class="dropdown-item"
                                                        v-if="
                            gateway.status === 1 &&
                            gateway.gateway_type === 0 &&
                            gateway.type === 3
                          "
                                                >{{ gateway.title }}
                                                </router-link
                                                >
                                                <router-link
                                                        :to="`/settlement-settings/ipg/${gateway.id}`"
                                                        class="dropdown-item"
                                                        v-if="
                            gateway.status === 1 &&
                            gateway.gateway_type === 0 &&
                            gateway.type === 1
                          "
                                                >{{ gateway.title }}
                                                </router-link
                                                >
                                                <router-link
                                                        :to="`/settlement-settings/ipg/${gateway.id}`"
                                                        class="dropdown-item"
                                                        v-if="
                            gateway.status === 1 &&
                            gateway.gateway_type === 0 &&
                            gateway.type === 2
                          "
                                                >{{ gateway.title }}
                                                </router-link
                                                >
                                                <router-link
                                                        :to="`/settlement-settings/vip/${gateway.id}`"
                                                        class="dropdown-item"
                                                        v-if="gateway.status === 1 && gateway.gateway_type === 2"
                                                >{{ gateway.title }}
                                                </router-link
                                                >
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 my-1 my-button" style="text-align: left">
                    <router-link
                        :to="'#'"
                        :class="{ 'disabled-button-class': true }"
                        class="text-end btn w-100 title_font_size_btn d-flex align-items-center justify-content-around"
                        :style="disabledNoneActiveWallet"
                        style="text-align: right; border-radius: 20px; box-shadow: 0 0 5px #8ce3d6"
                        :disabled="true"
                    >
                        <svg
                            :style="true ? 'display: block;' : 'display: none;'"
                            class="lock-icon"
                            fill="#a0a0a0"
                            height="24"
                            viewBox="0 0 24 24"
                            width="24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g data-v-3cc0e907="" fill="none">
                                <path d="M0 0h24v24H0V0z" data-v-3cc0e907=""></path>
                                <path d="M0 0h24v24H0V0z" data-v-3cc0e907="" opacity=".87"></path>
                            </g>
                            <path
                                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                                    data-v-3cc0e907=""
                            ></path>
                        </svg>
                        <span class="m-icon-two px-4 router-link-white w-100">
              <svg
                      class="mx-3 bi bi-credit-card"
                      fill="currentColor"
                      height="16"
                      viewBox="0 0 16 16"
                      width="16"
                      xmlns="http://www.w3.org/2000/svg"
              >
                <path
                        d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"
                />
                <path
                        d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"
                />
              </svg>
              {{ $t("wallets.label.wallet_to_wallet") }}</span
                        >
                        <div></div>
                    </router-link>
                </div>
                <div class="col-md-3 my-1 my-button">
                    <div class="dropdown w-100">
                        <div
                                :style="disabledNoneActiveWallet"
                                class="title_font_size_btn btn dropdown-toggle w-100 d-flex justify-content-around"
                                data-toggle="dropdown"
                                style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6"
                                type="button"
                        >
                            <svg
                                    :style="showLockIcon"
                                    class="display-none-in-sm"
                                    data-v-3cc0e907=""
                                    fill="#a0a0a0"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    xmlns="http://www.w3.org/2000/svg"
                            >
                                <g data-v-3cc0e907="" fill="none">
                                    <path d="M0 0h24v24H0V0z" data-v-3cc0e907=""></path>
                                    <path d="M0 0h24v24H0V0z" data-v-3cc0e907="" opacity=".87"></path>
                                </g>
                                <path
                                        d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                                        data-v-3cc0e907=""
                                ></path>
                            </svg>

                            <span class="m-icon-three px-4 router-link-white"
                            ><svg
                                    class="mx-3 bi bi-graph-down-arrow"
                                    fill="currentColor"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    width="16"
                                    xmlns="http://www.w3.org/2000/svg"
                            >
                  <path
                          d="M0 0h1v15h15v1H0V0Zm10 11.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-1 0v2.6l-3.613-4.417a.5.5 0 0 0-.74-.037L7.06 8.233 3.404 3.206a.5.5 0 0 0-.808.588l4 5.5a.5.5 0 0 0 .758.06l2.609-2.61L13.445 11H10.5a.5.5 0 0 0-.5.5Z"
                          fill-rule="evenodd"
                  />
                </svg>
                {{ $t("wallets.label.settlement") }}</span
                            >
                            <i class="fa fa-dollar"></i>
                        </div>
                        <div class="dropdown-menu w-100">
                            <router-link
                                    :to="`/wallets/settlement/${walletData.id}`"
                                    class="dropdown-item title_font_size_settlement"
                                    v-text="$t('wallets.label.settlement_request')"
                            ></router-link>
                            <router-link
                                    :to="`/wallets/auto-settlement/${walletData.id}`"
                                    class="dropdown-item title_font_size_settlement"
                                    v-text="$t('wallets.label.auto_settlement_settings')"
                            ></router-link>
                            <router-link
                                    :to="`/wallets/settlement-list/${walletData.id}`"
                                    class="dropdown-item title_font_size_settlement"
                                    v-text="$t('wallets.label.settlement_reports')">
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="mt-1 col-md-3 w-100 my-button">
                    <router-link
                            :style="disabledNoneActiveWallet"
                            :to="`/wallets/password/${walletData.id}`"
                            class="btn w-100 title_font_size_btn d-flex align-items-center justify-content-around"
                            style="text-align: right; border-radius: 20px; box-shadow: 0 0 5px #8ce3d6"
                    >
                        <svg
                                :style="showLockIcon"
                                class="display-none-in-sm"
                                data-v-3cc0e907=""
                                fill="#a0a0a0"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                            <g data-v-3cc0e907="" fill="none">
                                <path d="M0 0h24v24H0V0z" data-v-3cc0e907=""></path>
                                <path d="M0 0h24v24H0V0z" data-v-3cc0e907="" opacity=".87"></path>
                            </g>
                            <path
                                    d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                                    data-v-3cc0e907=""
                            ></path>
                        </svg>

                        <span class="m-icon-four router-link-white"
                        ><svg
                                class="mx-3 bi bi-pencil-square"
                                fill="currentColor"
                                height="16"
                                viewBox="0 0 16 16"
                                width="16"
                                xmlns="http://www.w3.org/2000/svg"
                        >
                <path
                        d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                />
                <path
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                        fill-rule="evenodd"
                /></svg
                        >{{ $t("label.access_password") }}</span
                        >
                        <div></div>
                    </router-link>
                </div>
            </div>
            <active-token v-show="false"
                    :title="$t('label.bank_status')"
            />
            <div class="row my-3"></div>
            <div class="row">
                <div class="col-md-6">
                    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
                        <div class="px-3">
                            <div class="d-flex mb-3">
                                <div class="px-4 ml-auto">{{ $t('wallets.label.transaction_reports') }}</div>
                                <div class="px-4">
                                    <router-link
                                            :to="`wallets/transaction/${walletData.id}`"
                                            class="text-success"
                                    >{{ $t('wallets.label.view-all') }}
                                    </router-link
                                    >
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-responsive table-borderless text-center">
                                    <thead>
                                    <tr>
                                        <th
                                                scope="col"
                                                style="background-color: #eee; border-radius: 0 16px 16px 0"
                                        >
                                            {{ $t('label.identifier') }}
                                        </th>
                                        <th scope="col" style="background-color: #eee">{{ $t('label.amount_rial') }}
                                        </th>
                                        <th scope="col" style="background-color: #eee">{{ $t('label.date_created') }}
                                        </th>
                                        <th scope="col" style="background-color: #eee; cursor: pointer">
                                            <span class="mx-2">{{ $t('label.status') }}</span>
                                        </th>
                                        <th
                                                class="sm_size_width_100"
                                                colspan="2"
                                                scope="col"
                                                style="background-color: #eee; border-radius: 16px 0 0 16px"
                                        >
                                            {{ $t('label.type') }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="walletTableDataTransaction.length > 0">
                                    <tr
                                            :key="index"
                                            v-for="(transaction, index) in walletTableDataTransaction"
                                    >
                                        <td class="en_num py-3">{{ transaction.id }}</td>
                                        <td class="py-3">{{ transaction.amount }}</td>
                                        <td class="py-3">{{ transaction.created_at }}</td>
                                        <td class="py-3">
                        <span
                                :class="[
                            'label label-inline' +
                              ' label-light-' +
                              walletTransactionStatusVariant(transaction.status),
                          ]"
                        >{{ walletTransactionStatusStr.get(transaction.status) }}</span
                        >
                                        </td>
                                        <td class="py-3" colspan="2">
                        <span
                                :class="[
                            'label label-inline' +
                              ' label-light-' +
                              walletTransactionTypeVariant(transaction.type),
                          ]"
                        >{{ walletTransactionTypeStr.get(transaction.type) }}</span
                        >
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else>
                                    <div>
                                        <img
                                                src="@/assets/new/image/not-found_new.png"
                                                style="margin: 1rem 0 0 -33rem"
                                                width="200"
                                        />
                                    </div>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
                        <div class="px-3">
                            <div class="d-flex mb-3">
                                <div class="px-4 ml-auto">{{ $t('wallets.label.settlement_reports') }}</div>
                                <div class="px-4">
                                    <router-link
                                            :to="`/wallets/settlement-list/${walletData.id}`"
                                            class="text-success"
                                    >{{ $t('wallets.label.view-all') }}
                                    </router-link
                                    >
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-responsive table-borderless text-center">
                                    <thead>
                                    <tr>
                                        <th
                                                scope="col"
                                                style="background-color: #eee; border-radius: 0 16px 16px 0"
                                        >
                                            {{ $t('label.identifier') }}
                                        </th>
                                        <th scope="col" style="background-color: #eee">{{ $t('label.amount_rial') }}
                                        </th>
                                        <th scope="col" style="background-color: #eee">{{ $t('label.date_created') }}
                                        </th>
                                        <th scope="col" style="background-color: #eee; cursor: pointer">
                                            <span class="mx-2">{{ $t('label.status') }}</span>
                                        </th>
                                        <th
                                                class="sm_size_width_100"
                                                colspan="2"
                                                scope="col"
                                                style="background-color: #eee; border-radius: 16px 0 0 16px"
                                        >
                                            {{ $t('label.type') }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody v-if="walletTableDataSettlement.length > 0">
                                    <tr
                                            :key="index"
                                            v-for="(transaction, index) in walletTableDataSettlement"
                                    >
                                        <td class="en_num py-3">{{ transaction.id }}</td>
                                        <td class="py-3">{{ transaction.amount }}</td>
                                        <td class="py-3">{{ transaction.created_at }}</td>
                                        <td class="py-3">
                        <span
                                :class="[
                            'label label-inline' +
                              ' label-light-' +
                              walletTransactionStatusVariant(transaction.status),
                          ]"
                        >{{ walletTransactionStatusStr.get(transaction.status) }}</span
                        >
                                        </td>
                                        <td class="py-3" colspan="2">
                        <span
                                :class="[
                            'label label-inline' +
                              ' label-light-' +
                              walletTransactionTypeVariant(transaction.type),
                          ]"
                        >{{ walletTransactionTypeStr.get(transaction.type) }}</span
                        >
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else>
                                    <div>
                                        <img
                                                src="@/assets/new/image/not-found_new.png"
                                                style="margin: 1rem 0 0 -33rem"
                                                width="200"
                                        />
                                    </div>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section v-else>
            <page-title icon="wallets" title_text="کیف پول"></page-title>
<!--            <description-->
<!--                    :bill_gateway="1"-->
<!--                    :info_list="[-->
<!--          'شارژ کیف با استفاده از تراکنش های درگاه های پرداخت',-->
<!--          'شارژ کیف بصورت انتقال بین بانکی از طریق پنل پی‌استار',-->
<!--          'شارژ کیف بصورت پرداخت از درگاه پی‌استار',-->
<!--          'برداشت از کیف و انتقال به حساب های بانکی ذی‌نفعان',-->
<!--        ]"-->
<!--                    info_title="تسویه وجوه دریافتی از مشتریان به کیف‌پول و انتقال موجودی کیف به کیف‌پول یا واریز به حساب های بانکی مختلف"-->
<!--                    learn_more_url="https://paystar.ir/wallet"-->
<!--                    link_url="/wallets/create"-->
<!--            >-->
<!--                <template v-slot:svg>-->
<!--                    <svg-->
<!--                            data-v-485955f4=""-->
<!--                            fill="#00bea5"-->
<!--                            height="48"-->
<!--                            viewBox="0 0 24 24"-->
<!--                            width="48"-->
<!--                            xmlns="http://www.w3.org/2000/svg"-->
<!--                    >-->
<!--                        <path d="M0 0h24v24H0V0z" data-v-485955f4="" fill="none"></path>-->
<!--                        <path-->
<!--                                d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.37-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"-->
<!--                                data-v-485955f4=""-->
<!--                        ></path>-->
<!--                        <circle cx="16" cy="12" data-v-485955f4="" r="1.5"></circle>-->
<!--                    </svg>-->
<!--                </template>-->
<!--            </description>-->
        </section>

        <div id="overlay" v-if="status == 'loading'">
            <div
                    class="p-3"
                    style="
          position: absolute;
          top: 50%;
          left: 50%;
          color: gray;
          background-color: white;
        "
            >
                <div class="spinner-border text-success" role="status"></div>
                <span> {{ $t('wallets.label.wallet-waiting') }} </span>
            </div>
        </div>
    </div>
</template>

<script>
    import PageTitle from "@/components/main/components/pageTitle";
    import $ from "jquery";
    import {walletService} from "@/common/api.service";
    import DashboardBox from "@/pages/dashboard/dashboard-box";
    import {walletStatus, walletStatusStr, walletStatusVariant,} from "@/constants/walletStatus";
    import Description from "@/pages/gateways/description";
    import {walletTransactionTypeStr, walletTransactionTypeVariant,} from "@/constants/walletTransactionType";
    import {walletTransactionStatusStr, walletTransactionStatusVariant,} from "@/constants/walletTransactionStatus";
    import {mapGetters} from "vuex";
    import ActiveToken from "./active-token.vue";
    import toastr from 'toastr';

    export default {
        components: {DashboardBox, Description, PageTitle, ActiveToken},
        data() {
            return {
                walletStatusVariant,
                walletStatus,
                walletStatusStr,
                wallets: [],
                walletData: {},
                walletTableDataSettlement: [],
                walletTableDataTransaction: [],
                walletTransactionTypeStr,
                walletTransactionStatusStr,
                walletTransactionStatusVariant,
                walletTransactionTypeVariant,
                walletSelected: null,
                showTransactionGateway: false,
                status: 'loading',
                isLoading: false,
            };
        },
        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }
                return toastr
            },
            ...mapGetters("gateway", ["gateways"]),
            disabledNoneActiveWallet() {
                // To Disable Inactive Wallets
                return [this.walletData.status === 2 ? {pointerEvents: "none"} : ""];
            },
            showLockIcon() {
                return [this.walletData.status === 2 ? {display: "block"} : {display: "none"}];
            },
            gateways_after_search() {
                let result = [];

                if (this.status == "success") {
                    for (let g in this.gateways) {
                        if (this.gateways[g].title.includes(this.search_gateway_title)) {
                            result.push(this.gateways[g]);
                        }
                    }
                }

                return result;
            },
        },
        methods: {
            reloadBalanceMethod() {
      this.isLoading = true;
      this.status = "loading";
      walletService
        .reloadBalance()
        .then((response) => {
          this.getWallets();

        })
        .catch(({response}) => {
          this.isLoading = false;
          this.status = "error";
          this.toastr.error(response.data.message)
        });
    },

    getWallets() {
      let params = {
        wallet_prefix: "A",
      };

      walletService
        .get(params)
        .then((res) => {
          this.wallets = res.data.data;
          this.status = "ok";
          if (this.wallets.length > 0) {
            const selectedWallet = window.localStorage.getItem("wallet_selected");

            if (
              selectedWallet &&
              this.wallets.find((wallet) => wallet.id === selectedWallet)
            ) {
              this.walletSelected = selectedWallet;
            } else {
              $("#dashboard_data_select").val(this.wallets[0].id).change();
              this.walletSelected = this.wallets[0].id;
            }
          }
            this.toastr.success('اطلاعات با موفقیت آپدیت شد.')
        })
        .catch(({response})=> {
          console.error("Error fetching wallets: ", error);
          this.status = "error";
          this.toastr.error(response.data.message)
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
            copyText(text) {
                navigator.clipboard.writeText(text);
                let el = document.getElementById("btn_copy_wallet_hashid");
                el.classList.remove("fa-copy");
                el.classList.add("fa-check");

                setTimeout(() => {
                    el.classList.remove("fa-check");
                    el.classList.add("fa-copy");
                }, 1500);
            },
            fetchWalletTransactionAndSettlementData(id) {
                this.$store.dispatch('wallet/fetchWalletTransaction', this.walletData.id).then(res => {
                    this.walletTableDataSettlement = res.data.data.data;
                }).catch(error => {
                    throw new Error(error)
                });

                this.$store.dispatch('wallet/fetchWalletSettlementData', this.walletData.id).then(res => {
                    this.walletTableDataTransaction = res.data.data.data;
                }).catch(error => {
                    throw new Error(error)
                })
            },
        },
        watch: {
            walletSelected(id) {
                this.wallets.find((wallet) => {
                    if (wallet.id === id) {
                        this.walletData = wallet;
                    }
                });

                this.fetchWalletTransactionAndSettlementData(id);
                window.localStorage.setItem("wallet_selected", String(id));
            },
        },
        mounted() {
            let params = {
                wallet_prefix: "A",
            };

            walletService.get(params).then(res => {
                this.wallets = res.data.data;
                this.status = 'ok';
                if (this.wallets.length > 0) {
                    if (window.localStorage.getItem("wallet_selected") &&
                        this.wallets.find(wallet => wallet.id == window.localStorage.getItem("wallet_selected")) != undefined
                    ) {
                        this.walletSelected = window.localStorage.getItem("wallet_selected");
                    } else {
                        $("#dashboard_data_select").val(this.wallets[0].id).change();
                        this.walletSelected = this.wallets[0].id;
                    }
                }
            });

            this.$store.dispatch("gateway/fetch").then(() => {
                if (this.gateways.length > 0) {
                    this.gateways.forEach(gateway => {
                        if (gateway.gateway_type === 0 || gateway.gateway_type === 2) {
                            if (gateway.type === 1 || gateway.type === 3 || gateway.type === 2) {
                                if (gateway.status === 1) {
                                    this.showTransactionGateway = true;
                                }
                            }
                        }
                    });
                }
            });
        },
    };
</script>

<style scoped>
    .form-cn {
        background-color: #444 !important;
        color: #dedede !important;
        border-color: #333 !important;
        border-radius: 15px;
        padding: 0.25rem 1rem;
    }

    .wallet-flex {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        justify-content: space-between;
    }

    .wallet-item-flex {
        display: flex;
        align-items: center;
    }

    .cp_pointer {
        cursor: pointer;
    }

    /* Idea */
    .wallet-logo {
        width: 160px;
        height: 160px;
        border-radius: 50%;
        border: 1px solid #333;
    }

    .title_font_size {
        font-size: 13px;
    }

    .title_font_size_btn {
        font-size: 14px;
    }

    .title_font_size_settlement {
        font-size: 13px;
    }

    .wallet-flex div {
        margin: 0 0.4rem;
    }

    .wallet-flex div:nth-child(3) {
        margin: 0 1rem 0 0;
    }

    .wallet-flex div:nth-child(4) {
        margin: 0 0.5rem 0 0;
    }

    #wallet_list_mobile_view {
        display: none;
    }

    .ml-create-wallet {
        margin: 0 1.5rem 0 0;
    }

    .dropdowns {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .dropdowns li {
        position: relative;
        margin: 0;
        padding: 0;
    }

    .dropdowns li a {
        text-align: center;
        text-decoration: none;
        display: block;
        /* padding: 10px; */
    }

    .dropdowns li ul {
        position: absolute;
        top: -0.6vw;
        right: 15.3vw;
        margin: 0;
        padding: 0.1rem 0;
        list-style: none;
        display: none;
        line-height: normal;
    }

    .dropdowns li ul li a {
        text-align: left;
        font-size: 13px;
        padding: 10px;
        display: block;
    }

    /* .dropdowns li ul li ul {
      left: 100%;
      top: 0;
    } */

    ul:hover li > ul {
        display: block;
    }

    /* .ml-match-size-settlement-mobile {
      margin: 0;
    } */

    @media screen and (max-width: 2000px) {
        .dropdowns li ul {
            right: 11.2vw;
        }
    }

    @media screen and (max-width: 1900px) {
        .dropdowns li ul {
            right: 12.2vw;
        }
    }

    @media screen and (max-width: 1800px) {
        .dropdowns li ul {
            right: 13.1vw;
        }
    }

    @media screen and (max-width: 1700px) {
        .dropdowns li ul {
            right: 14.1vw;
        }
    }

    @media screen and (max-width: 1600px) {
        .dropdowns li ul {
            right: 15.2vw;
        }
    }

    @media screen and (max-width: 1500px) {
        .dropdowns li ul {
            right: 16.2vw;
        }
    }

    @media screen and (max-width: 1300px) {
        .dropdowns li ul {
            right: 16vw;
        }
    }

    @media screen and (max-width: 1200px) {
        .dropdowns li ul {
            right: 15.2vw;
        }
    }

    @media screen and (max-width: 1100px) {
        .dropdowns li ul {
            right: 14.3vw;
        }
    }

    @media screen and (max-width: 1000px) {
        .wallet-flex {
            flex-direction: column-reverse;
            align-items: center;
            justify-content: center;
            width: 100%;
        }

        .wallet-item-flex {
            flex-direction: column;
            width: 100%;
        }

        .wallet-flex div:nth-child(3) {
            margin: 0.7rem 0;
        }

        .wallet-flex div:nth-child(4) {
            margin: 0.7rem 0;
        }

        .w-sm-100 {
            width: 100%;
        }

        #wallet_list_mobile_view {
            display: block;
        }

        #lg_wallet_list {
            display: none;
        }

        .m-icon-one {
            margin: 0 0 0 15rem;
        }

        .m-icon-three {
            margin: 0 0 0 16.5rem;
        }

        .m-icon-four {
            margin: 0 0 0 13rem;
        }

        .ml-create-wallet {
            margin: 0;
        }

        .title_font_size {
            font-size: 10px;
        }

        .title_font_size_btn {
            font-size: 10px;
        }

        .title_font_size_settlement {
            font-size: 10px;
        }

        .dropdowns li ul {
            right: 13vw;
            font-size: 10px;
            /* padding: 0 10rem; */
        }

        .dropdowns li ul li a {
            font-size: 10px;
        }

        .display-none-in-sm {
            display: none !important;
        }
    }

    @media screen and (max-width: 900px) {
        .dropdowns li ul {
            right: 12.2vw;
        }

        .m-icon-one {
            margin: 0 0 0 20rem;
        }

        .m-icon-three {
            margin: 0 0 0 30rem;
        }

        .m-icon-four {
            margin: 0 0 0 26rem;
        }
    }

    @media screen and (max-width: 767px) {
        .m-icon-one {
            margin: 0 0 0 28rem;
        }

        .m-icon-three {
            margin: 0 0 0 30rem;
        }

        .m-icon-four {
            margin: 0 0 0 26rem;
        }
    }

    @media screen and (max-width: 677px) {
        .sm_size_width_100 {
            width: 100%;
        }

        .dropdowns li ul {
            top: 27px;
        }

        .m-icon-one {
            margin: 0 0 0 28rem;
        }

        .m-icon-three {
            margin: 0 0 0 30rem;
        }

        .m-icon-four {
            margin: 0 0 0 26rem;
        }

        .my-button {
            margin: 1rem 0 !important;
        }
    }

    @media screen and (max-width: 577px) {
        .m-icon-one {
            margin: 0 0 0 28rem;
        }

        .m-icon-three {
            margin: 0 0 0 30rem;
        }

        .m-icon-four {
            margin: 0 0 0 26rem;
        }
    }

    @media screen and (max-width: 501px) {
        .m-icon-one {
            margin: 0 0 0 25rem;
        }

        .m-icon-three {
            margin: 0 0 0 26.5rem;
        }

        .m-icon-four {
            margin: 0 0 0 23rem;
        }
    }

    @media screen and (max-width: 415px) {
        .m-icon-one {
            margin: 0 0 0 18rem;
        }

        .m-icon-three {
            margin: 0 0 0 20rem;
        }

        .m-icon-four {
            margin: 0 0 0 17rem;
        }
    }

    @media screen and (max-width: 412px) {
        .m-icon-one {
            margin: 0 0 0 18rem;
        }

        .m-icon-three {
            margin: 0 0 0 20rem;
        }

        .m-icon-four {
            margin: 0 0 0 17rem;
        }
    }

    @media screen and (max-width: 400px) {
        .m-icon-one {
            margin: 0 0 0 15rem;
        }

        .m-icon-three {
            margin: 0 0 0 16.5rem;
        }

        .m-icon-four {
            margin: 0 0 0 13rem;
        }

        i {
            font-size: 9px !important;
        }
    }

    @media screen and (max-width: 361px) {
        .m-icon-one {
            margin: 0 0 0 14rem;
        }

        .m-icon-three {
            margin: 0 0 0 15rem;
        }

        .m-icon-four {
            margin: 0 0 0 11rem;
        }
    }
    .disabled-button-class {
        pointer-events: none;
        opacity: 0.5;
        cursor: not-allowed;
    }
</style>
